import React, { useEffect, useState } from 'react';
import { t } from 'ttag';

interface DefaultInfoBarProps {
    background?: string | null
}

const getInfoBarClassName = (background?: string | null) => {
    const classes = [`InfoBar`];
    const allowedBackgrounds = [`InfoBar--yellow`, `InfoBar--darkBlue`];

    if (background && allowedBackgrounds.includes(background)) {
        classes.push(background);
    }

    return classes.join(` `);
}

const DefaultInfoBar = (props: DefaultInfoBarProps) => {
    // const [visible, setVisible] = useState(false);
    const [visible, setVisible] = useState(true);
    const emptyText = t`Redmine.InfoBar.Text` === `Redmine.InfoBar.Text`;

    /*
    useEffect(() => {
        const cookie = document.cookie.match(new RegExp(`(^| )info-bar-hidden=([^;]+)`));
        if (cookie === null) {
            setVisible(true);
        }
    }, []);
    */

    function hideInfoBar() {
        setVisible(false);
        /*
        const date = new Date();
        date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
        const expires = `; expires=${date.toUTCString()}`;
        document.cookie = `info-bar-hidden=true${expires}; path=/`;
        */
    }

    if (!visible || emptyText) {
        return null;
    }

    return (
        <div className={getInfoBarClassName(props.background)}>
            <div>
                <p dangerouslySetInnerHTML={{ __html: t`Redmine.InfoBar.Text` }} />
                <a href={t`Redmine.InfoBar.Link.Url`} dangerouslySetInnerHTML={{ __html: t`Redmine.InfoBar.Link.Text` }} />
            </div>
            <button onClick={hideInfoBar}></button>
        </div>
    );
}

export default DefaultInfoBar;
